import Account from './Account'
import Add from './Add'
import Analysed from './Analysed'
import ApproxEquals from './ApproxEquals'
import ArrowBack from './ArrowBack'
import ArrowCircle from './ArrowCircle'
import ArrowDown from './ArrowDown'
import ArrowLeft from './ArrowLeft'
import ArrowRight from './ArrowRight'
import ArrowUp from './ArrowUp'
import Back from './Back'
import Balance from './Balance'
import BarChart from './BarChart'
import Bell from './Bell'
import BellFill from './BellFill'
import Book from './Book'
import Books from './Books'
import BreadcrumbSeparator from './BreadcrumbSeparator'
import Bullseye from './Bullseye'
import Check from './Check'
import Checklist from './Checklist'
import ChevronDown from './ChevronDown'
import ChevronLeft from './ChevronLeft'
import ChevronRight from './ChevronRight'
import { ChevronUpDown } from './ChevronUpDown'
import CircleDash from './CircleDash'
import CircleFilled from './CircleFilled'
import CircleOutline from './CircleOutline'
import Close from './Close'
import Configure from './Configure'
import Copy from './Copy'
import Cross from './Cross'
import Crosshair from './Crosshair'
import Dash from './Dash'
import DataPage from './DataPage'
import Delete from './Delete'
import Documents from './Documents'
import DoubleChevronLeft from './DoubleChevronLeft'
import DoubleChevronRight from './DoubleChevronRight'
import Download from './Download'
import Downloading from './Downloading'
import Drag from './Drag'
import DropdownArrow from './DropdownArrow'
import Earth from './Earth'
import Email from './Email'
import Excel from './Excel'
import ExclamationInCircle from './ExclamationInCircle'
import ExclamationInCircleFilled from './ExclamationInCircleFilled'
import Explore from './Explore'
import Eye from './Eye'
import EyeClosed from './EyeClosed'
import EyeOpen from './EyeOpen'
import Filter from './Filter'
import Filters from './Filters'
import FunctionFormula from './FunctionFormula'
import Fundamentals from './Fundamentals'
import Growth from './Growth'
import Hamburger from './Hamburger'
import Help from './Help'
import Hidden from './Hidden'
import Hourglass from './Hourglass'
import Info from './Info'
import Kebab from './Kebab'
import Key from './Key'
import Lightbulb from './Lightbulb'
import LightningBolt from './LightningBolt'
import LightningBoltFill from './LightningBoltFill'
import Link from './Link'
import ListView from './ListView'
import Lock from './Lock'
import LogOut from './LogOut'
import Logo from './Logo'
import LogoText from './LogoText'
import MagnifyingGlass from './MagnifyingGlass'
import MatchCase from './MatchCase'
import Menu from './Menu'
import Minus from './Minus'
import MinusSquare from './MinusSquare'
import ModeBright from './ModeBright'
import ModeDark from './ModeDark'
import No from './No'
import { Pencil } from './Pencil'
import { Pending } from './Pending'
import { PendingReverse } from './PendingReverse'
import { Pin } from './Pin'
import Plus from './Plus'
import PlusSquare from './PlusSquare'
import Processing from './Processing'
import Report from './Report'
import RobotHead from './RobotHead'
import Scales from './Scales'
import ScreenSliders from './ScreenSliders'
import Sdg from './Sdg'
import SdgAffordableHousing from './SdgAffordableHousing'
import SdgAir from './SdgAir'
import SdgCleanEnergy from './SdgCleanEnergy'
import SdgClimateChange from './SdgClimateChange'
import SdgDecentWork from './SdgDecentWork'
import SdgEducation from './SdgEducation'
import SdgFinancialInclusion from './SdgFinancialInclusion'
import SdgFood from './SdgFood'
import SdgGenderDiversity from './SdgGenderDiversity'
import SdgHealthcare from './SdgHealthcare'
import SdgIndustry from './SdgIndustry'
import SdgSustainableFinance from './SdgSustainableFinance'
import SdgWaste from './SdgWaste'
import SdgWater from './SdgWater'
import Search from './Search'
import Settings from './Settings'
import Sliders from './Sliders'
import { Stack } from './Stack'
import Stars from './Stars'
import Stats from './Stats'
import Success from './Success'
import Swap from './Swap'
import ThumbnailView from './ThumbnailView'
import Tick from './Tick'
import TickInCircle from './TickInCircle'
import UpDownArrows from './UpDownArrows'
import Upload from './Upload'
import UserProfile from './UserProfile'
import Warning from './Warning'
import XLarge from './XLarge'
import XSmall from './XSmall'

export const icons = {
  Account,
  Add,
  Analysed,
  ApproxEquals,
  ArrowBack,
  ArrowCircle,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Back,
  Balance,
  BarChart,
  Bell,
  BellFill,
  Book,
  Books,
  BreadcrumbSeparator,
  Bullseye,
  Check,
  Checklist,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUpDown,
  CircleDash,
  CircleFilled,
  CircleOutline,
  Close,
  Configure,
  Copy,
  Cross,
  Crosshair,
  Dash,
  DataPage,
  Delete,
  Documents,
  DoubleChevronLeft,
  DoubleChevronRight,
  Download,
  Downloading,
  Drag,
  DropdownArrow,
  Earth,
  Email,
  Excel,
  ExclamationInCircle,
  ExclamationInCircleFilled,
  Explore,
  Eye,
  EyeClosed,
  EyeOpen,
  Filter,
  Filters,
  FunctionFormula,
  Fundamentals,
  Growth,
  Hamburger,
  Help,
  Hidden,
  Hourglass,
  Info,
  Kebab,
  Key,
  Lightbulb,
  LightningBolt,
  LightningBoltFill,
  Link,
  ListView,
  Lock,
  Logo,
  LogoText,
  LogOut,
  MagnifyingGlass,
  MatchCase,
  Menu,
  Minus,
  MinusSquare,
  ModeBright,
  ModeDark,
  No,
  Pencil,
  Pending,
  PendingReverse,
  Pin,
  Plus,
  PlusSquare,
  Processing,
  Report,
  RobotHead,
  Scales,
  ScreenSliders,
  SdgAffordableHousing,
  SdgAir,
  SdgCleanEnergy,
  SdgClimateChange,
  SdgDecentWork,
  SdgEducation,
  SdgFinancialInclusion,
  SdgFood,
  SdgGenderDiversity,
  SdgHealthcare,
  SdgIndustry,
  Sdg,
  SdgSustainableFinance,
  SdgWaste,
  SdgWater,
  Search,
  Settings,
  Sliders,
  Stack,
  Stars,
  Stats,
  Success,
  Swap,
  ThumbnailView,
  Tick,
  TickInCircle,
  Upload,
  UpDownArrows,
  UserProfile,
  Warning,
  XLarge,
  XSmall,
}

export type IconName = keyof typeof icons
